import type { AgGridFetchFunction } from '@/app/common/components/ag-grid/types';

/** AgGridWrapper's default `perPage`; the page-1 query must request the same size. */
export const GRID_PAGE_SIZE = 50;

interface PageResult<Row> {
  rows: Row[];
  total: number;
}

/**
 * AgGridWrapper server mode reads `fetchFunction(body).unwrap()` as `{ data: { rows, total } }`,
 * but the Tracker AI baseQuery already strips the `{ code, msg, data }` envelope — re-wrap it here.
 * `body` = grid `page/perPage/sort` + the caller's `additionalData` (projectId + list body).
 */
export function toGridFetchFunction<Arg, Row, Out = Row>(
  trigger: (arg: Arg) => { unwrap: () => Promise<PageResult<Row>> },
  mapRow?: (row: Row) => Out
): AgGridFetchFunction {
  return body => ({
    unwrap: () =>
      trigger(body as Arg)
        .unwrap()
        .then(result => ({
          data: {
            rows: mapRow ? result.rows.map(mapRow) : result.rows,
            total: result.total
          }
        }))
  });
}
